import { connect } from 'react-redux'
import { SlidesProgress } from './SlidesProgress'
import slideActions from '../../dataStore/actions/slides'

const mapStateToProps = (state) => ({
  stage: state.slides.isUploading ? 'uploading' : 'processing',
  progress: state.slides.isUploading ? state.slides.uploadProgress : state.slides.processingProgress
})

const mapDispatchToProps = (dispatch) => ({
  onCancel: () => {

    dispatch(slideActions.cancelUpload())

  }
})

export default connect(mapStateToProps, mapDispatchToProps)(SlidesProgress)
